<template>
	<div v-katex:auto>
		<publicHeader @child-event="myInfoEvent"></publicHeader>
		<studyHeader :subjectIndex="subjectIndex" :studyNav="studyNav" :myInfo="myInfo" :public="public"></studyHeader>
		<div class="practice bg_gray practice_second">
			<div class="my_position flex">
				<div class="my_position_l cl_gray">
					<img src="../../../static/icon_position.png" class="mar5" />
					<p>当前位置：<router-link to="/" class="cl_gray">首页</router-link>  >  <router-link to="/study" class="cl_gray">趣学习</router-link>
						>  {{data.paperName}}</p>
				</div>
				<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
			</div>
			<div class="w1200 flex practice_test" v-if="data.paperques.length > 0">
				<div class="practice_l bg_white radius8">
					<div class="practice_l_title f26px cl_dark">
						<p>{{data.paperName}}</p>
					</div>
					<div class="practice_l_cont mat30">
						<!-- 单选题，多选题，双选题，选择题 -->
						<div class="question_list" v-for="(item,index) in data.paperques" :id="item.id">
							<div class="question_list_l f18px">{{index + 1}}、</div>
							<div class="choice_div" v-if="item.qtpye == '单选题' || item.qtpye == '多选题' || item.qtpye == '双选题' || item.qtpye == '选择题'">
								<div class="choice_title f18px" v-html="item.title"></div>
								<div class="choice_div_cont mat15 f16px cl_gray">
									<div class="choice_list radius8 flex" :class="{'on':item.option_a_ture}" v-if="item.option_a != ''" @click="check(index,'A',item.answer1,item.qtpye)">
										<div class="choice_list_l">A</div>
										<div class="choice_list_r" v-html="item.option_a"></div>
									</div>
									<div class="choice_list radius8 flex" :class="{'on':item.option_b_ture}" v-if="item.option_b != ''" @click="check(index,'B',item.answer1,item.qtpye)">
										<div class="choice_list_l">B</div>
										<div class="choice_list_r" v-html="item.option_b"></div>
									</div>
									<div class="choice_list radius8 flex" :class="{'on':item.option_c_ture}" v-if="item.option_c != ''" @click="check(index,'C',item.answer1,item.qtpye)">
										<div class="choice_list_l">C</div>
										<div class="choice_list_r" v-html="item.option_c"></div>
									</div>
									<div class="choice_list radius8 flex" :class="{'on':item.option_d_ture}" v-if="item.option_d != ''" @click="check(index,'D',item.answer1,item.qtpye)">
										<div class="choice_list_l">D</div>
										<div class="choice_list_r" v-html="item.option_d"></div>
									</div>
									<div class="choice_list radius8 flex" :class="{'on':item.option_e_ture}" v-if="item.option_e != ''" @click="check(index,'E',item.answer1,item.qtpye)">
										<div class="choice_list_l">E</div>
										<div class="choice_list_r" v-html="item.option_e"></div>
									</div>
								</div>
								<div class="cl_yel mat10" v-if="['单选题','选择题'].indexOf(item.qtpye) < 0">本题无法线上作答，请线下作答<br>提交答题卡后可校对答案进行批改</div>
							</div>
							<div class="other_div" v-else>
								<div class="choice_title f18px" v-html="item.title"></div>
								<div class="other_second cl_gray" v-if="item.isSub == 1">
									<div class="other_second_list mat20" v-for="(second,index) in item.subquestions" :key="index" :id="second.id">
										<div class="other_second_list_l f18px">{{index + 1}}、</div>
										<div class="other_second_list_r f18px" v-html="second.title"></div>
									</div>
								</div>
								<div class="cl_yel mat10">本题无法线上作答，请线下作答<br>提交答题卡后可校对答案进行批改</div>
							</div>
						</div>
					</div>
				</div>
				<div class="practice_r bg_white radius8">
					<div class="practice_r_title">
						<img src="../../../static/test_time.png" class="mar5" />
						<div class="practice_r_time f16px">
							<span class="cl_dark">用时：</span>
							<p class="cl_white">{{myHours}}:{{myMinutes}}:{{mySeconds}}</p>
						</div>
					</div>
					<div class="question_index_div mat25 cl_dark">
						<div class="question_index" v-for="(item,index) in data.paperques" :key="index">
							<div class="question_index_title bg_gray radius" v-if="item.isSub != 1" @click="toIndex(item.id)" :class="{'on':item.my_answer != ''}">{{index+1}}</div>
							<div class="question_index_second" v-else>
								<div class="question_index_second_list bg_gray radius" v-for="(second,indexSecond) in item.subquestions" :key="indexSecond" @click="toIndex(second.id)">{{index+1}}-{{indexSecond+1}}</div>
							</div>
						</div>
					</div>
					<div class="practice_r_btm tc mat20">
						<div class="practice_r_submit f18px cl_white mal15 radius20" @click="submit">交卷</div>
					</div>
				</div>
			</div>
		</div>
		<vfooter @child-event="publicEvent"></vfooter>
		<!-- 校对答案 -->
		<div class="bg" v-if="proofShow == true"></div>
		<div class="proof bg_white radius8 bs" :class="{'on':proofShow}">
			<div class="proof_close">
				<img src="../../../static/close_violet.png" class="cur" @click="proofClose" />
			</div>
			<div class="proof_title f22px">校对答案</div>
			<div class="proof_nav cl_dark mat10">
				<div class="proof_nav_list radius cur" v-for="(item,index) in paper" :key="index" v-if="item != undefined" :class="[{'on':paperCur.id==item.id},{'already':paper[index].correctTure}]" @click="proofNav(index)">{{index+1}}</div>
			</div>
			<div class="proof_cont mat20">
				<div class="proof_subject">
					<div class="proof_subject_title f16px" v-html="paperCur.title"></div>
					<div class="proof_subject_cont cl_gray mat20" v-if="paperCur.subquestions">
						<div class="proof_subject_list" v-for="(item,index) in paperCur.subquestions" :key="index" v-html="item.title"></div>
					</div>
					<div class="proof_subject_check mat20" v-if="paperCur.option_a != ''">
						<div class="proof_subject_check_list" v-if="paperCur.option_a != ''">
							<div class="proof_subject_check_list_l">A.</div>
							<div class="proof_subject_check_list_r" v-html="paperCur.option_a"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paperCur.option_b != ''">
							<div class="proof_subject_check_list_l">B.</div>
							<div class="proof_subject_check_list_r" v-html="paperCur.option_b"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paperCur.option_c != ''">
							<div class="proof_subject_check_list_l">C.</div>
							<div class="proof_subject_check_list_r" v-html="paperCur.option_c"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paperCur.option_d != ''">
							<div class="proof_subject_check_list_l">D.</div>
							<div class="proof_subject_check_list_r" v-html="paperCur.option_d"></div>
						</div>
						<div class="proof_subject_check_list" v-if="paperCur.option_e != ''">
							<div class="proof_subject_check_list_l">E.</div>
							<div class="proof_subject_check_list_r" v-html="paperCur.option_e"></div>
						</div>
					</div>
				</div>
				<div class="proof_analysis mat20">
					<div class="proof_analysis_l f18px">答案：</div>
					<div class="proof_analysis_r" v-html="paperCur.answer2"></div>
				</div>
				<div class="proof_analysis mat20">
					<div class="proof_analysis_l f18px">解析：</div>
					<div class="proof_analysis_r" v-html="paperCur.parse"></div>
				</div>
			</div>
			<div class="proof_btm cl_violet f18px flex tc mat20">
				<div class="proof_btm_list radius8 cur" @click="proofBtn(1)" :class="{'on':paperCur.correct == 1&&paperCur.correctTure == true}">正确</div>
				<div class="proof_btm_list radius8 cur" @click="proofBtn(0.5)" :class="{'on':paperCur.correct == 0.5&&paperCur.correctTure == true}">部分正确</div>
				<div class="proof_btm_list radius8 cur" @click="proofBtn(0)" :class="{'on':paperCur.correct == 0&&paperCur.correctTure == true}">错误</div>
			</div>
			<div class="proof_submit mat20">
				<div class="radius8 cl_white inline tc proof_submit_btn cur" @click="proofSubmit">提交</div>
			</div>
		</div>
	</div>
</template>

<script>
	import publicHeader from '../../components/header.vue'
	import studyHeader from '../../components/study_header.vue'
	import vfooter from '../../components/footer.vue'
	export default {
	  name: 'practice_list',
		components: {
			publicHeader,
			studyHeader,
			vfooter,
		},
	  props: {
	    
	  },
		data () {
			return {
				subjectIndex: false, //学科分类显示
				studyNav: -1, //导航
				myInfo: {},
				public: {},
				data: {}, //试卷
				paper: [], //需要校对的题目
				currentTime:0, //计时器
				timeObj: null,
				myHours: '00',
				myMinutes: '00',
				mySeconds: '00',
				proofShow: false, //校对答案显示
				paperNav: 0, //校对题目默认选中
				paperCur: {},
				id: "",
				knowledge_id: "",
				start_time: "",
				end_time: "",
				questions_id_str: "",
				paperName: "",
				task_id: "",
			}
		},
		created() {
			
			console.log(this.$route)
			if (this.$route.query.id) {
				
				this.id = this.$route.query.id;
				this.getDetails();
			}
			if (this.$route.query.knowledge_id) {
				this.knowledge_id = this.$route.query.knowledge_id;
				this.diff = this.$route.query.diff;
				this.limit = this.$route.query.limit;
				this.getPractice();
			}
			if (this.$route.query.questions_id_str) {
				this.questions_id_str = this.$route.query.questions_id_str;
				this.knowledge_id = this.$route.query.knowledge_basic_id;
				this.paperName = this.$route.query.paperName;
				this.getVideoPaper();
			}
			if (this.$route.query.task_id) {
				this.task_id = this.$route.query.task_id;
				this.getTask();
			}
		},
		destroyed () {
			clearInterval(this.timer);
		},
		mounted() {
			this.testTimer();
			this.start_time = this.getTime();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getTime () {
				let t = "";
				let myDate = new Date();
				let year = myDate.getFullYear();
				let month = myDate.getMonth() + 1;
				let date = myDate.getDate();
				let hours = myDate.getHours();
				let minutes = myDate.getMinutes();
				let seconds = myDate.getSeconds();
				if (month < 10) {
					month = "0" + month;
				}
				if (date < 10) {
					date = "0" + date;
				}
				if (hours < 10) {
					hours = "0" + hours;
				}
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				t = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
				return t;
			},
			//作业题目
			getTask () {
				this.$get("/api/student/get_my_homework_unfinished_dtl",{
					token: localStorage.getItem("token"),
					id: this.task_id,
				})
				.then(res => {
					this.data = res.data.data;
					for (let i = 0; i < this.data.paperques.length; i++) {
                            

						this.data.paperques[i].option_a_ture = false;
						this.data.paperques[i].option_b_ture = false;
						this.data.paperques[i].option_c_ture = false;
						this.data.paperques[i].option_d_ture = false;
						this.data.paperques[i].option_e_ture = false;
						this.data.paperques[i].my_answer = "";
						this.data.paperques[i].correct = 0; //0错误1正确0.5部分正确
						this.data.paperques[i].correctTure = false;
						this.data.paperques[i].paperIndex = i;
						if (['单选题','选择题'].indexOf(this.data.paperques[i].qtpye) < 0) {
							this.data.multiple = true;
						}
					}
				});
			},
			//练习题目
			getPractice () {
				this.$get("/api/exercise/get_questions_data",{
					token: localStorage.getItem("token"),
					knowledge_id: this.knowledge_id,
					diff: this.diff,
					limit: this.limit,
				})
				.then(res => {
					this.data = res.data;
					for (let i = 0; i < this.data.paperques.length; i++) {
						this.data.paperques[i].option_a_ture = false;
						this.data.paperques[i].option_b_ture = false;
						this.data.paperques[i].option_c_ture = false;
						this.data.paperques[i].option_d_ture = false;
						this.data.paperques[i].option_e_ture = false;
						this.data.paperques[i].my_answer = "";
						this.data.paperques[i].correct = 0; //0错误1正确0.5部分正确
						this.data.paperques[i].correctTure = false;
						this.data.paperques[i].paperIndex = i;
						if (['单选题','选择题'].indexOf(this.data.paperques[i].qtpye) < 0) {
							this.data.multiple = true;
						}
					}
				});
			},
			//试卷题目
			getDetails () {
				console.log('detail')
				this.$get("/api/funlearning/get_papers_questions_data",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					this.data = res.data;
					for (let i = 0; i < this.data.paperques.length; i++) {
						this.data.paperques[i].option_a_ture = false;
						this.data.paperques[i].option_b_ture = false;
						this.data.paperques[i].option_c_ture = false;
						this.data.paperques[i].option_d_ture = false;
						this.data.paperques[i].option_e_ture = false;
						this.data.paperques[i].my_answer = "";
						this.data.paperques[i].correct = 0; //0错误1正确0.5部分正确
						this.data.paperques[i].correctTure = false;
						this.data.paperques[i].paperIndex = i;
						if (['单选题','选择题'].indexOf(this.data.paperques[i].qtpye) < 0) {
							this.data.multiple = true;
						}
					}
				});
			},
			//课后习题
			getVideoPaper () {
				this.$get("/api/exercise/get_after_class_questions_data",{
					token: localStorage.getItem("token"),
					question_ids: this.questions_id_str,
				})
				.then(res => {
					this.data = res.data;
					this.data.paperName = this.paperName;
					for (let i = 0; i < this.data.paperques.length; i++) {
						this.data.paperques[i].option_a_ture = false;
						this.data.paperques[i].option_b_ture = false;
						this.data.paperques[i].option_c_ture = false;
						this.data.paperques[i].option_d_ture = false;
						this.data.paperques[i].option_e_ture = false;
						this.data.paperques[i].my_answer = "";
						this.data.paperques[i].correct = 0; //0错误1正确0.5部分正确
						this.data.paperques[i].correctTure = false;
						this.data.paperques[i].paperIndex = i;
						if (['单选题','选择题'].indexOf(this.data.paperques[i].qtpye) < 0) {
							this.data.multiple = true;
						}
					}
				});
			},
			//计时
			testTimer(){
				this.timeFunction();
				this.timer = setInterval(() => {
					this.timeFunction();
				}, 1000)
			},
			timeFunction(){
				// 开始执行倒计时
				this.timeObj = { // 时间对象
					seconds: Math.floor(this.currentTime % 60),
					minutes: Math.floor(this.currentTime / 60) % 60,
					hours: Math.floor(this.currentTime / 60 / 60) % 24
				}
				// 计算出时分秒
				this.myHours = this.timeObj.hours<10?'0'+this.timeObj.hours:this.timeObj.hours;
				this.myMinutes = this.timeObj.minutes<10?'0'+this.timeObj.minutes:this.timeObj.minutes;
				this.mySeconds = this.timeObj.seconds<10?'0'+this.timeObj.seconds:this.timeObj.seconds;
				this.currentTime++;
			},
			//索引跳转
			toIndex (e) {
				document.getElementById(e).scrollIntoView();
			},
			//选择题
			check (index,letter,answer,qtpye) {
				var that = this;
				var paperques = that.data.paperques;
				//判断是否为单选
				if (['单选题','选择题'].indexOf(qtpye) < 0) {
					that.$message({
						duration: 2000,
						message: "多选题只能线下作答",
						type: 'warning'
					});
					return false
				} else {
					letter = letter.toLowerCase();
					paperques[index].option_a_ture = false;
					paperques[index].option_b_ture = false;
					paperques[index].option_c_ture = false;
					paperques[index].option_d_ture = false;
					paperques[index].option_e_ture = false;
					
					let option = 'option_' + letter + '_ture';
					paperques[index][option] = true;
					paperques[index].my_answer = letter.toUpperCase();
				}
			},
			//交卷
			submit () {
				var that = this;
				var data = that.data;
				var paperques = data.paperques;
				var paper = [].concat(paperques);
				that.$messageBox.confirm('确认作答完毕，准备交卷吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (data.multiple == true) {
						that.proofShow = true;
						for (let i = 0; i < paper.length; i++) {
							if (paper[i].qtpye == "单选题" || paper[i].qtpye == "选择题") {
								delete paper[i];
							}
						}
						that.paper = paper;
						for (let k = 0; k < that.paper.length; k++) {
							if (that.paper[k] != undefined) {
								that.paperCur = that.paper[k];
								return
							}
						}
					} else {
						that.proofSubmit()
					}
				}).catch(() => {
					that.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			proofClose () {
				this.proofShow = false;
			},
			//校对导航
			proofNav (e) {
				this.paperNav = e;
				this.paperCur = this.paper[e];
			},
			//校对正确
			proofBtn (e) {
				if (this.paperCur.correctTure == false) {
					var index = this.paperCur.paperIndex;
					this.data.paperques[index].correct = e;
					this.data.paperques[index].correctTure = true;
					this.paperCur.correctTure = true;
				} else {
					return false
				}
			},
			//校对提交
			proofSubmit () {
				var that = this;
				var paperques = that.data.paperques;
				var probability = 0;
				var arr = [];
				for (let i = 0; i < paperques.length; i++) {
					if (paperques[i].qtpye == "单选题" || paperques[i].qtpye == "选择题") {
						if (paperques[i].answer1 == paperques[i].my_answer) {
							paperques[i].correct = 1;
						} else {
							paperques[i].correct = 0;
						}
					}
					probability += paperques[i].correct;
					arr.push({id: paperques[i].id, reply: paperques[i].my_answer, is_right: paperques[i].correct, mark: paperques[i].sorces});
				}
				this.end_time = this.getTime();
				probability = probability/paperques.length;
				probability = Number(probability*100).toFixed(0);
				probability += "%";
				that.data.probability = probability;
				arr = JSON.stringify(arr);
				if (that.task_id == "") {
					that.$get("/api/funlearning/post_topic_handed",{
						token: localStorage.getItem("token"),
						arr: arr,
						start_time: this.start_time,
						end_time: this.end_time,
						paper_id: this.id,
						knowledge_basic_id: this.knowledge_id,
					})
					.then(res => {
						var paper = {};
						paper = that.data;
						paper.time = that.myHours + ":" + that.myMinutes + ":" + that.mySeconds;
						paper.record_accuracy = res.data.accuracy;
						paper.record_time = res.data.time;
						paper = JSON.stringify(paper);
						localStorage.setItem("paper", paper);
						this.$message({
							duration: 2000,
							message: "提交成功",
							type: 'success'
						});
						setTimeout(() => {
							this.$router.push({path: '/report'});
						}, 2000);
					});
				} else {
					that.$get("/api/student/post_my_homework_submit",{
						token: localStorage.getItem("token"),
						arr: arr,
						start_time: this.start_time,
						end_time: this.end_time,
						id: this.task_id,
					})
					.then(res => {
						this.$message({
							duration: 2000,
							message: "提交成功",
							type: 'success'
						});
						setTimeout(() => {
							this.$router.push({path: '/task_report', query: {id: this.task_id}});
						}, 2000);
					});
				}
			},
		},
	}
</script>

<style>
</style>
